var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Product-Update"}},[_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }